import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http'
import {
	ApplicationConfig,
	ErrorHandler,
	importProvidersFrom,
	provideZoneChangeDetection,
} from '@angular/core'
import { MatDialogModule } from '@angular/material/dialog'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { provideAnimations } from '@angular/platform-browser/animations'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { provideRouter, withComponentInputBinding } from '@angular/router'

import { initializeApp, provideFirebaseApp } from '@angular/fire/app'
import { getAuth, provideAuth } from '@angular/fire/auth'
import { getDatabase, provideDatabase } from '@angular/fire/database'

import { environment } from '@env'
import { NgxMaskConfig, provideEnvironmentNgxMask } from 'ngx-mask'

import { freedompayConfigurationInitializer } from '@initializers/freedompay-configuration'
import { locationConfigurationInitializer } from '@initializers/location-configuration'
import { recaptchaInitializer } from '@initializers/recaptcha'
import { ticketInfoInitializer } from '@initializers/ticket-info'
import { urlParamsInitializer } from '@initializers/url-params'
import { bodyInterceptor } from '@interceptors/body'
import { headersInterceptor } from '@interceptors/headers'
import { identifiersInterceptor } from '@interceptors/identifiers'
import { recaptchaInterceptor } from '@interceptors/recaptcha'
import { CrashErrorHandler } from '@services/crash-error-handler'

import { routes } from './app.routes'

const maskConfig: Partial<NgxMaskConfig> = {
	validation: false,
}

const firebaseApp = initializeApp(environment.firebaseConfig)

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection(),
		{ provide: ErrorHandler, useClass: CrashErrorHandler },
		provideFirebaseApp(() => firebaseApp),
		provideAuth(() => getAuth(firebaseApp)),
		provideDatabase(() => getDatabase(firebaseApp)),
		provideRouter(routes, withComponentInputBinding()),
		provideAnimations(),
		provideHttpClient(
			withInterceptorsFromDi(),
			withInterceptors([
				headersInterceptor,
				bodyInterceptor,
				identifiersInterceptor,
				recaptchaInterceptor,
			])
		),
		importProvidersFrom(MatDialogModule, MatSnackBarModule),
		provideAnimationsAsync(),
		provideEnvironmentNgxMask(maskConfig),
		recaptchaInitializer,
		freedompayConfigurationInitializer,
		urlParamsInitializer,
		ticketInfoInitializer,
		locationConfigurationInitializer,
	],
}
